import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=83e747c4&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&id=83e747c4&prod&scoped=true&lang=css&"
import style1 from "./Program.vue?vue&type=style&index=1&id=83e747c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e747c4",
  null
  
)

export default component.exports